import React from "react";
import { InputGroup, InputRightAddon, NumberInput, NumberInputField } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import FieldFrame from "./FieldFrame";

const PercentageField = ({ field, control, disabled, error, required, compact }) => (
  <Controller
    control={control}
    name={field.code}
    render={({ field: input }) => (
      <FieldFrame field={field} error={error} isRequired={required} compact={compact}>
        <InputGroup>
          <NumberInput
            value={input.value ?? ""}
            precision={field.uiConfig?.precision ?? 2}
            step={field.uiConfig?.step || 0.01}
            isDisabled={disabled}
            onChange={(_, valueAsNumber) => input.onChange(Number.isNaN(valueAsNumber) ? "" : valueAsNumber)}
          >
            <NumberInputField placeholder={field.placeholder} fontWeight={compact ? "semibold" : "normal"} />
          </NumberInput>
          <InputRightAddon>%</InputRightAddon>
        </InputGroup>
      </FieldFrame>
    )}
  />
);

export default PercentageField;
